import React from "react";
import { formatDateTime } from "../../../shared/dateTimeUtils";

const sections = ["hematologyFishboneData", "chemistryFishboneData"];

export function checkIfHasData(model) {
  // the data is considered empty is both fishbones are null.
  return !!sections.find((section) => model[section]);
}

export function checkIfHasDataForTimeRange(model) {
  const output = sections.reduce((total, section) => {
    return Object.keys(model[section] || {}).reduce((total2, key) => {
      let reading = model[section][key];
      if (reading && reading.value) {
        return true;
      }
      return total2;
    }, false);
  }, false);
  return model.count > 0 && output;
}

export default function LabsTile({ model, title }) {
  let formatNumber = new Intl.NumberFormat().format;
  let hasData = checkIfHasData(model);
  let hasDataForTimeRange = checkIfHasDataForTimeRange(model);
  return (
    <React.Fragment>
      <div className="title">
        {title} ({model.hours}h)
      </div>
      <div className="tile-content labs">
        {!hasData && <div className="no-results">No Labs</div>}
        {hasData &&
          sections.map((section) => (
            <div className={section} key={section}>
              <div className="time">
                {hasDataForTimeRange
                  ? formatDateTime(model[section].timestamp, "•")
                  : "No Recent Labs"}
              </div>
              {Object.keys(model[section]).map((key) => {
                let reading = model[section][key];
                return reading && reading.value ? (
                  <div
                    className={`value ${key} normalcy-type-${reading.normalcyType}`}
                    key={key}
                  >
                    {formatNumber(reading.value)}
                  </div>
                ) : null;
              })}
            </div>
          ))}
      </div>
    </React.Fragment>
  );
}
